import { useDiscountData } from "@chef/state-management/hooks";
import { Hr } from "@chef/components";

import { Discount } from "./Discount";

interface TemporaryDiscountProps {
  hasDivider?: boolean;
}

export const TemporaryDiscount = ({
  hasDivider = true,
}: TemporaryDiscountProps) => {
  const {
    discounts: {
      activeDiscounts: { temporaryDiscounts },
    },
  } = useDiscountData();

  const { nextTemporaryDiscount } = temporaryDiscounts;

  if (!nextTemporaryDiscount) {
    return null;
  }

  return (
    <>
      {hasDivider && <Hr className="my-4" />}
      <Discount discount={nextTemporaryDiscount} type="temporary" />
    </>
  );
};
